import { type MantineColor, Text, type TextProps } from '@mantine/core';

type ColorLabelProps = TextProps & {
  c?: MantineColor;
  children: React.ReactNode;
};

function ColorLabel({ c, children, ...props }: ColorLabelProps) {
  return (
    <Text size="xs" fw={600} c={c} {...props}>
      {children}
    </Text>
  );
}

export default ColorLabel;
